export default __webpack_public_path__ + "static/media/monkey-4.05950f46.png";